/* ==========================================================================
   NYIGEN SMART SEARCH
   Version: 2026-10-21
   Ignite core untouched.
   ========================================================================== */

(() => {
  'use strict';

  if (window.__NYIGEN_SMART_SEARCH_V5__) return;
  window.__NYIGEN_SMART_SEARCH_V5__ = true;

  const VISIBLE_QUERY_PARAM = 'nyigen_q';

  const STOP_WORDS = new Set([
    'og',
    'and',
    'the',
    'til',
    'for',
    'med',
    'en',
    'et',
    'i',
    'på',
    'af',
    'with'
  ]);

  const rule = (
    id,
    priority,
    triggers,
    filters,
    titleTerms = [],
    qualifierMode = 'title'
  ) => ({
    id,
    priority,
    triggers,
    filters,
    titleTerms,
    qualifierMode
  });


  /* ==========================================================================
     SEARCH RULES
     ========================================================================== */

  const SEARCH_RULES = [


    /* ========================================================================
       TILBEHØR
       Uses Nyigen's real product tags
       ======================================================================== */

    rule(
      'privacy-screen',
      120,
      [
        'privacy screen',
        'privacy'
      ],
      [
        'product_type:"Tilbehør"',
        'tag:"Skærmbeskyttelse"'
      ],
      [
        'privacy'
      ],
      'title'
    ),


    rule(
      'screen-protectors',
      110,
      [
        'skærmbeskyttelse',
        'skaermbeskyttelse',
        'screen protector',
        'screen protectors',
        'beskyttelsesglas',
        'panserglas'
      ],
      [
        'product_type:"Tilbehør"',
        'tag:"Skærmbeskyttelse"'
      ],
      [],
      'any'
    ),


    rule(
      'cables',
      110,
      [
        'kabler',
        'kabel',
        'cables',
        'cable',
        'ladekabel',
        'opladningskabel'
      ],
      [
        'product_type:"Tilbehør"',
        'tag:"Kabler"'
      ],
      [],
      'any'
    ),


    rule(
      'fast-chargers',
      120,
      [
        'hurtigoplader',
        'hurtig oplader',
        'fast charger'
      ],
      [
        'product_type:"Tilbehør"',
        'tag:"opladere"'
      ],
      [
        'hurtigoplader'
      ],
      'any'
    ),


    rule(
      'chargers',
      110,
      [
        'opladere',
        'oplader',
        'chargers',
        'charger',
        'adapter'
      ],
      [
        'product_type:"Tilbehør"',
        'tag:"opladere"'
      ],
      [],
      'any'
    ),


    rule(
      'covers',
      110,
      [
        'covers',
        'cover',
        'cases',
        'case',
        'etui'
      ],
      [
        'product_type:"Tilbehør"',
        'tag:"Covers"'
      ],
      [],
      'any'
    ),


    rule(
      'powerbanks',
      110,
      [
        'powerbanks',
        'powerbank',
        'power bank',
        'power banks'
      ],
      [
        'product_type:"Tilbehør"',
        'tag:"powerbank"'
      ],
      [],
      'any'
    ),


    /* ========================================================================
       AIRPODS / HEADSETS
       ======================================================================== */

    rule(
      'airpods',
      100,
      [
        'airpods',
        'airpod'
      ],
      [
        'product_type:"Headsets"'
      ],
      [
        'airpods'
      ],
      'title'
    ),


    rule(
      'beats',
      100,
      [
        'beats'
      ],
      [
        'product_type:"Headsets"',
        'vendor:"Beats"'
      ],
      [],
      'any'
    ),


    rule(
      'headsets',
      90,
      [
        'headsets',
        'headset',
        'headphones',
        'hovedtelefoner',
        'høretelefoner',
        'horetelefoner',
        'earbuds'
      ],
      [
        'product_type:"Headsets"'
      ],
      [],
      'any'
    ),


    /* ========================================================================
       SMARTWATCHES
       ======================================================================== */

    rule(
      'apple-watch',
      100,
      [
        'apple watch'
      ],
      [
        'product_type:"smartwatches"'
      ],
      [
        'apple',
        'watch'
      ],
      'title'
    ),


    rule(
      'galaxy-watch',
      100,
      [
        'galaxy watch',
        'samsung watch'
      ],
      [
        'product_type:"smartwatches"'
      ],
      [
        'watch'
      ],
      'title'
    ),


    rule(
      'smartwatches',
      90,
      [
        'smartwatches',
        'smartwatch',
        'smart watch'
      ],
      [
        'product_type:"smartwatches"'
      ],
      [],
      'any'
    ),


    /* ========================================================================
       TABLETS / IPAD
       ======================================================================== */

    rule(
      'ipad',
      100,
      [
        'ipad'
      ],
      [
        'product_type:"Tablets"'
      ],
      [
        'ipad'
      ],
      'title'
    ),


    rule(
      'galaxy-tab',
      100,
      [
        'galaxy tab',
        'samsung tab'
      ],
      [
        'product_type:"Tablets"'
      ],
      [
        'tab'
      ],
      'title'
    ),


    rule(
      'tablets',
      90,
      [
        'tablets',
        'tablet'
      ],
      [
        'product_type:"Tablets"'
      ],
      [],
      'any'
    ),


    /* ========================================================================
       COMPUTERS
       ======================================================================== */

    rule(
      'macbook',
      80,
      [
        'macbook'
      ],
      [
        'product_type:"Computere"'
      ],
      [
        'macbook'
      ]
    ),


    rule(
      'imac',
      80,
      [
        'imac'
      ],
      [
        'product_type:"Computere"'
      ],
      [
        'imac'
      ]
    ),


    rule(
      'mac-mini',
      80,
      [
        'mac mini'
      ],
      [
        'product_type:"Computere"'
      ],
      [
        'mac',
        'mini'
      ]
    ),


    rule(
      'asus',
      80,
      [
        'asus'
      ],
      [
        'product_type:"Computere"'
      ],
      [
        'asus'
      ]
    ),


    rule(
      'lenovo',
      80,
      [
        'lenovo'
      ],
      [
        'product_type:"Computere"'
      ],
      [
        'lenovo'
      ]
    ),


    rule(
      'acer',
      80,
      [
        'acer'
      ],
      [
        'product_type:"Computere"'
      ],
      [
        'acer'
      ]
    ),


    rule(
      'dell',
      80,
      [
        'dell'
      ],
      [
        'product_type:"Computere"'
      ],
      [
        'dell'
      ]
    ),


    rule(
      'hp',
      80,
      [
        'hp'
      ],
      [
        'product_type:"Computere"'
      ],
      [
        'hp'
      ]
    ),


    rule(
      'computers',
      70,
      [
        'computere',
        'computer',
        'laptop',
        'laptops',
        'pc'
      ],
      [
        'product_type:"Computere"'
      ],
      [],
      'any'
    ),


    /* ========================================================================
       SMARTPHONES
       ======================================================================== */

    rule(
      'iphone',
      60,
      [
        'iphone'
      ],
      [
        'product_type:"Smartphones"'
      ],
      [
        'iphone'
      ]
    ),


    rule(
      'samsung',
      60,
      [
        'samsung'
      ],
      [
        'product_type:"Smartphones"'
      ],
      [
        'samsung'
      ]
    ),


    rule(
      'galaxy',
      60,
      [
        'galaxy'
      ],
      [
        'product_type:"Smartphones"'
      ],
      [
        'galaxy'
      ]
    ),


    rule(
      'oneplus',
      60,
      [
        'oneplus',
        'one plus'
      ],
      [
        'product_type:"Smartphones"'
      ],
      [
        'oneplus'
      ]
    ),


    rule(
      'pixel',
      60,
      [
        'google pixel',
        'pixel'
      ],
      [
        'product_type:"Smartphones"'
      ],
      [
        'pixel'
      ]
    ),


    rule(
      'huawei',
      60,
      [
        'huawei'
      ],
      [
        'product_type:"Smartphones"'
      ],
      [
        'huawei'
      ]
    ),


    rule(
      'sony',
      60,
      [
        'sony',
        'xperia'
      ],
      [
        'product_type:"Smartphones"'
      ]
    ),


    rule(
      'xiaomi',
      60,
      [
        'xiaomi',
        'redmi',
        'poco'
      ],
      [
        'product_type:"Smartphones"'
      ]
    ),


    rule(
      'motorola',
      60,
      [
        'motorola'
      ],
      [
        'product_type:"Smartphones"'
      ],
      [
        'motorola'
      ]
    ),


    rule(
      'nokia',
      60,
      [
        'nokia'
      ],
      [
        'product_type:"Smartphones"'
      ],
      [
        'nokia'
      ]
    ),


    rule(
      'oppo',
      60,
      [
        'oppo'
      ],
      [
        'product_type:"Smartphones"'
      ],
      [
        'oppo'
      ]
    ),


    rule(
      'honor',
      60,
      [
        'honor'
      ],
      [
        'product_type:"Smartphones"'
      ],
      [
        'honor'
      ]
    ),


    rule(
      'nothing-phone',
      60,
      [
        'nothing phone'
      ],
      [
        'product_type:"Smartphones"'
      ],
      [
        'nothing'
      ]
    ),


    rule(
      'smartphones',
      50,
      [
        'smartphones',
        'smartphone',
        'mobiltelefon',
        'mobiltelefoner',
        'mobil',
        'mobiler'
      ],
      [
        'product_type:"Smartphones"'
      ],
      [],
      'any'
    )

  ];


  /* ==========================================================================
     HELPERS
     ========================================================================== */

  function normalize(value) {
    return String(value || '')
      .trim()
      .replace(/\s+/g, ' ');
  }


  function fold(value) {
    return normalize(value)
      .toLowerCase()
      .replace(/æ/g, 'ae')
      .replace(/ø/g, 'o')
      .replace(/å/g, 'a')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }


  function escapeSearchValue(value) {
    return String(value || '')
      .replace(/\\/g, '\\\\')
      .replace(/"/g, '\\"');
  }


  function tokenize(value) {
    return fold(value)
      .split(/\s+/)
      .map((token) =>
        token
          .replace(/^[^\p{L}\p{N}]+/gu, '')
          .replace(/[^\p{L}\p{N}-]+$/gu, '')
      )
      .filter(Boolean);
  }


  function isTechnicalQuery(value) {
    return /(?:^|\s)(?:title|product_type|tag|vendor)\s*:/i
      .test(normalize(value));
  }


  function containsPhrase(query, trigger) {
    return ` ${fold(query)} `
      .includes(` ${fold(trigger)} `);
  }


  /* ==========================================================================
     RULE MATCHING
     ========================================================================== */

  function scoreTrigger(query, trigger) {
    const q = fold(query);
    const t = fold(trigger);

    if (!q || !t) {
      return 0;
    }


    if (q === t) {
      return 6000 + t.length;
    }


    if (containsPhrase(q, t)) {
      return 5000 + t.length;
    }


    const qTokens =
      q.split(/\s+/);

    const tTokens =
      t.split(/\s+/);


    if (
      qTokens.length === 1 &&
      tTokens.length === 1 &&
      q.length >= 3 &&
      t.startsWith(q)
    ) {
      return 3500 + q.length;
    }


    if (qTokens.length >= 2) {
      const lastToken =
        qTokens[qTokens.length - 1];

      if (
        lastToken.length >= 3 &&
        tTokens.some(
          (token) =>
            token.startsWith(lastToken)
        )
      ) {
        return 3200 + lastToken.length;
      }
    }


    return 0;
  }


  function resolveSearchRule(query) {
    let bestMatch = null;


    for (
      const currentRule
      of SEARCH_RULES
    ) {

      for (
        const trigger
        of currentRule.triggers
      ) {

        const triggerScore =
          scoreTrigger(
            query,
            trigger
          );


        if (!triggerScore) {
          continue;
        }


        const score =
          (currentRule.priority * 10000)
          +
          triggerScore;


        if (
          !bestMatch ||
          score > bestMatch.score
        ) {

          bestMatch = {
            rule: currentRule,
            trigger,
            score
          };

        }

      }

    }


    return bestMatch;
  }


  function getQualifierTokens(
    query,
    trigger
  ) {

    const queryTokens =
      tokenize(query);

    const triggerTokens =
      tokenize(trigger);


    return queryTokens.filter(
      (queryToken) => {

        if (
          STOP_WORDS.has(
            queryToken
          )
        ) {
          return false;
        }


        const belongsToTrigger =
          triggerTokens.some(
            (triggerToken) =>

              triggerToken ===
              queryToken

              ||

              triggerToken.startsWith(
                queryToken
              )

              ||

              queryToken.startsWith(
                triggerToken
              )

          );


        return !belongsToTrigger;

      }
    );
  }


  /* ==========================================================================
     BUILD SHOPIFY SEARCH QUERY
     ========================================================================== */

  function buildRuleQuery(
    visibleQuery,
    matchedRule
  ) {

    const {
      rule: currentRule,
      trigger
    } = matchedRule;


    const parts = [
      ...currentRule.filters
    ];


    const baseTitleTerms =
      Array.from(
        new Set(
          (currentRule.titleTerms || [])
            .map(fold)
            .filter(Boolean)
        )
      );


    baseTitleTerms.forEach(
      (term) => {

        parts.push(
          `title:"${escapeSearchValue(term)}"`
        );

      }
    );


    const qualifiers =
      Array.from(
        new Set(
          getQualifierTokens(
            visibleQuery,
            trigger
          )
            .map(fold)
            .filter(Boolean)
        )
      );


    qualifiers.forEach(
      (term) => {

        if (
          currentRule.qualifierMode ===
          'any'
        ) {

          parts.push(
            `"${escapeSearchValue(term)}"`
          );

        } else {

          parts.push(
            `title:"${escapeSearchValue(term)}"`
          );

        }

      }
    );


    return parts.join(' AND ');
  }


  function buildFallbackTitleQuery(
    visibleQuery
  ) {

    const terms =
      tokenize(visibleQuery)
        .filter(
          (term) =>
            !STOP_WORDS.has(term)
        );


    if (!terms.length) {
      return normalize(
        visibleQuery
      );
    }


    return Array.from(
      new Set(terms)
    )
      .map(
        (term) =>
          `title:"${escapeSearchValue(term)}"`
      )
      .join(' AND ');
  }


  function buildTechnicalQuery(
    visibleQuery
  ) {

    const cleanQuery =
      normalize(
        visibleQuery
      );


    if (!cleanQuery) {
      return '';
    }


    if (
      isTechnicalQuery(
        cleanQuery
      )
    ) {
      return cleanQuery;
    }


    const matchedRule =
      resolveSearchRule(
        cleanQuery
      );


    return matchedRule

      ? buildRuleQuery(
          cleanQuery,
          matchedRule
        )

      : buildFallbackTitleQuery(
          cleanQuery
        );

  }


  /* ==========================================================================
     KEEP TECHNICAL QUERY INVISIBLE
     ========================================================================== */

  function getVisibleQueryFromUrl() {

    try {

      return normalize(
        new URL(
          window.location.href
        )
          .searchParams
          .get(
            VISIBLE_QUERY_PARAM
          )
      );

    } catch (_) {

      return '';

    }

  }


  function fallbackVisibleFromTechnical(
    technicalQuery
  ) {

    const titleTerms = [];

    const titleRegex =
      /title:"([^"\\]*(?:\\.[^"\\]*)*)"/gi;

    let match;


    while (
      (
        match =
          titleRegex.exec(
            technicalQuery
          )
      ) !== null
    ) {

      titleTerms.push(
        match[1]
          .replace(/\\"/g, '"')
          .replace(/\\\\/g, '\\')
      );

    }


    if (
      titleTerms.length
    ) {
      return titleTerms.join(' ');
    }


    const tagMatch =
      technicalQuery.match(
        /tag:"([^"]+)"/i
      );


    if (tagMatch) {

      const tagNames = {

        skaermbeskyttelse:
          'skærmbeskyttelse',

        kabler:
          'kabel',

        opladere:
          'oplader',

        covers:
          'cover',

        powerbank:
          'powerbank'

      };


      return (
        tagNames[
          fold(tagMatch[1])
        ]
        ||
        ''
      );

    }


    return '';
  }


  function getVisibleQuery(
    technicalQuery
  ) {

    return (
      getVisibleQueryFromUrl()
      ||
      fallbackVisibleFromTechnical(
        technicalQuery
      )
    );

  }


  function cleanInput(input) {

    if (!input) {
      return;
    }


    const currentValue =
      normalize(
        input.value
      );


    if (
      !isTechnicalQuery(
        currentValue
      )
    ) {
      return;
    }


    const visibleValue =
      getVisibleQuery(
        currentValue
      );


    if (!visibleValue) {
      return;
    }


    input.value =
      visibleValue;


    input.setAttribute(
      'value',
      visibleValue
    );
  }


  function cleanAllSearchInputs() {

    document
      .querySelectorAll(
        'input[type="search"]'
      )
      .forEach(
        cleanInput
      );

  }


  /* ==========================================================================
     SEARCH RESULTS SUBMIT
     ========================================================================== */

  function isSearchForm(form) {

    if (
      !(form instanceof HTMLFormElement)
    ) {
      return false;
    }


    if (
      !form.querySelector(
        'input[type="search"]'
      )
    ) {
      return false;
    }


    try {

      const formUrl =
        new URL(
          form.action ||
          window.location.href,
          window.location.origin
        );


      return /\/search\/?$/
        .test(
          formUrl.pathname
        );

    } catch (_) {

      return false;

    }

  }


  function buildSearchResultsUrl(
    form,
    visibleQuery
  ) {

    const url =
      new URL(
        form.action ||
        '/search',
        window.location.origin
      );


    const technicalQuery =
      buildTechnicalQuery(
        visibleQuery
      );


    const formData =
      new FormData(form);


    url.search = '';


    for (
      const [key, value]
      of formData.entries()
    ) {

      if (
        !value ||
        key === 'q' ||
        key === 'type' ||
        key === VISIBLE_QUERY_PARAM
      ) {
        continue;
      }


      url.searchParams.append(
        key,
        value
      );

    }


    if (
      !url.searchParams.has(
        'options[prefix]'
      )
    ) {

      url.searchParams.set(
        'options[prefix]',
        'last'
      );

    }


    url.searchParams.set(
      'type',
      'product'
    );


    url.searchParams.set(
      'q',
      technicalQuery
    );


    url.searchParams.set(
      VISIBLE_QUERY_PARAM,
      visibleQuery
    );


    return url.toString();
  }


  document.addEventListener(
    'submit',

    (event) => {

      const form =
        event.target;


      if (
        !isSearchForm(form)
      ) {
        return;
      }


      const input =
        form.querySelector(
          'input[type="search"]'
        );


      const visibleQuery =
        normalize(
          input?.value
        );


      if (!visibleQuery) {
        return;
      }


      const predictiveSearch =
        form.closest(
          'predictive-search'
        );


      if (
        predictiveSearch &&
        predictiveSearch.querySelector(
          '[aria-selected="true"] a'
        )
      ) {
        return;
      }


      event.preventDefault();

      event.stopImmediatePropagation();


      window.location.assign(
        buildSearchResultsUrl(
          form,
          visibleQuery
        )
      );

    },

    true
  );


  /* ==========================================================================
     PREDICTIVE SEARCH
     ========================================================================== */

  const nativeFetch =
    window.fetch.bind(window);


  window.fetch =
    function nyigenSmartSearchFetch(
      resource,
      options
    ) {

      try {

        const originalUrl =

          resource instanceof Request

            ? resource.url

            : resource instanceof URL

              ? resource.href

              : String(resource);


        const url =
          new URL(
            originalUrl,
            window.location.origin
          );


        if (
          /\/search\/suggest(?:\.json)?\/?$/
            .test(
              url.pathname
            )
        ) {

          const rawQuery =
            normalize(
              url.searchParams.get(
                'q'
              )
            );


          if (
            rawQuery &&
            !isTechnicalQuery(
              rawQuery
            )
          ) {

            url.searchParams.set(
              'q',
              buildTechnicalQuery(
                rawQuery
              )
            );

          }


          url.searchParams.set(
            'resources[type]',
            'product'
          );


          url.searchParams.set(
            'resources[options][unavailable_products]',
            'show'
          );


          if (
            resource instanceof Request
          ) {

            resource =
              new Request(
                url.toString(),
                resource
              );

          } else if (
            resource instanceof URL
          ) {

            resource =
              url;

          } else {

            resource =
              url.origin ===
              window.location.origin

                ? (
                    url.pathname +
                    url.search +
                    url.hash
                  )

                : url.toString();

          }

        }

      } catch (_) {

      }


      return nativeFetch(
        resource,
        options
      );

    };


  /* ==========================================================================
     PROFESSIONAL NO-RESULTS STATE
     ========================================================================== */

  function renderNoResultsMessage() {

    const section =
      document.querySelector(
        '.section-main-search'
      );


    if (!section) {
      return;
    }


    let hasQuery = false;


    try {

      hasQuery =
        new URL(
          window.location.href
        )
          .searchParams
          .has('q');

    } catch (_) {

      hasQuery = false;

    }


    if (!hasQuery) {
      return;
    }


    const resultItems =
      section.querySelectorAll(
        'ul.product-grid > li.grid__item'
      );


    const isEmpty =
      resultItems.length === 0;


    section.classList.toggle(
      'nyigen-search-is-empty',
      isEmpty
    );


    const existingMessage =
      section.querySelector(
        '.nyigen-search-no-results'
      );


    if (!isEmpty) {

      existingMessage?.remove();

      return;

    }


    if (existingMessage) {
      return;
    }


    const host =

      section.querySelector(
        '.product-grid-container'
      )

      ||

      section.querySelector(
        '.template-search'
      )

      ||

      section;


    const message =
      document.createElement(
        'div'
      );


    message.className =
      'nyigen-search-no-results';


    message.setAttribute(
      'role',
      'status'
    );


    message.innerHTML = `
      <p class="nyigen-search-no-results__title">
        Vi fandt desværre ingen resultater.
      </p>

      <p class="nyigen-search-no-results__text">
        Prøv et andet søgeord, eller udforsk vores forslag nedenfor.
      </p>
    `;


    host.prepend(
      message
    );
  }


  let noResultsTimer =
    null;


  function scheduleNoResultsCheck() {

    window.clearTimeout(
      noResultsTimer
    );


    noResultsTimer =
      window.setTimeout(
        renderNoResultsMessage,
        40
      );

  }


  /* ==========================================================================
     INITIALIZATION
     ========================================================================== */

  document.addEventListener(
    'focusin',

    (event) => {

      if (
        event.target &&
        event.target.matches(
          'input[type="search"]'
        )
      ) {

        cleanInput(
          event.target
        );

      }

    },

    true
  );


  document.addEventListener(
    'DOMContentLoaded',

    () => {

      cleanAllSearchInputs();

      renderNoResultsMessage();


      const searchSection =
        document.querySelector(
          '.section-main-search'
        );


      if (searchSection) {

        const observer =
          new MutationObserver(
            scheduleNoResultsCheck
          );


        observer.observe(
          searchSection,
          {
            childList: true,
            subtree: true
          }
        );

      }

    }
  );


  window.addEventListener(
    'pageshow',

    () => {

      cleanAllSearchInputs();

      renderNoResultsMessage();

    }
  );


  document.addEventListener(
    'shopify:section:load',

    () => {

      cleanAllSearchInputs();

      renderNoResultsMessage();

    }
  );


  cleanAllSearchInputs();

})();